import React from 'react'

const CalenderTour = ({ setStepsEnabled, setHomeScreenWalkThroughPopup }) => {
  return (
    <div className="ContainerSubmitedSucess2 ">
      <div className="SubContainerSubmitedSucess innerContainerFlex">
        <div className="imageContainer">
          <img src="/gif/home_calendar_guide.gif" alt="" />
        </div>
        <div className="rightContainer">
          <div className="studentLogos leftMargin">
            <div></div>
            <div>
              <img
                src="/StudentImg/BreathSchoolLogo.png"
                alt="icon"
                width={"30px"}
              ></img>
            </div>
          </div>
          <div className=" overallMarginHead" style={{ position: "relative" }}>
            <h4 className="textColor1"> Welcome to Lectures Section</h4>
            <img style={{ width: "35px", height: "35px", position: "absolute", left: "87%", top: "195px", cursor: "pointer", zIndex: "999" }} src="./images/down_arrow.png" alt="arrowimag" onClick={() => {
              document.getElementById("last-paragraph").scrollIntoView({ behavior: "smooth" })
            }} />
          </div>

          <div className=" overallMargin">
            <p className="textColor2">
              1. Organized Daily and Weekly Timetables.
            </p>
            <hr></hr>
            <p className="textColor2" >
              2. Organized Assignments, Assessments and Summary for Lectures allow its Easy Access, Tracking and No Miss-outs.
            </p>
            <hr></hr>
            <p className="textColor2" >
              3. Better Time Management and Milestones execution through Study Planners.
            </p>
            <hr></hr>
            <p className="textColor2" >
              4. Synchronize Classroom Learning at Home.
            </p>
            <hr></hr>
            <p className="textColor2" id='last-paragraph'>
              5. Access the Holidays List
            </p>
            <hr></hr>
          </div>

          <div className="buttonsContainer">
            <button
              className="rightBtn"
              onClick={() => {
                setHomeScreenWalkThroughPopup(false);
                setStepsEnabled(true);
              }}
            >
              Take me to the product tour
            </button>
            <button
              className="leftBtn"
              onClick={() => setHomeScreenWalkThroughPopup(false)}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CalenderTour
